import PropTypes from 'prop-types';
import postsStrings from 'modules/posts/strings';

import { Wrapper, AddPostBtn } from './PostsHeader.style';

const PostsHeader = ({ handleAddPostBtnClick }) => (
  <Wrapper>
    <AddPostBtn as="button" onClick={handleAddPostBtnClick}>
      {postsStrings.postsHeader.addPostBtn}
    </AddPostBtn>
  </Wrapper>
);

PostsHeader.propTypes = {
  handleAddPostBtnClick: PropTypes.func.isRequired,
};

export default PostsHeader;
